var map = {
  "./ru.json": [
    "95089",
    "287650"
  ],
  "./uk.json": [
    "244794",
    "491619"
  ],
  "./bg.json": [
    "356306",
    "170237"
  ],
  "./el.json": [
    "728337",
    "536393"
  ],
  "./en-pt.json": [
    "465798",
    "822721"
  ],
  "./ja.json": [
    "83007",
    "171165"
  ],
  "./ar.json": [
    "63255",
    "373584"
  ],
  "./rw.json": [
    "684083",
    "463846"
  ],
  "./sr.json": [
    "511996",
    "168673"
  ],
  "./lol.json": [
    "744913",
    "570390"
  ],
  "./fr.json": [
    "225627",
    "871605"
  ],
  "./sv.json": [
    "686686",
    "674695"
  ],
  "./as.json": [
    "357070",
    "266468"
  ],
  "./gu.json": [
    "789760",
    "252283"
  ],
  "./kk.json": [
    "862335",
    "537903"
  ],
  "./nb.json": [
    "436548",
    "444318"
  ],
  "./ta.json": [
    "784020",
    "180318"
  ],
  "./ky.json": [
    "188836",
    "173105"
  ],
  "./pl.json": [
    "627220",
    "932605"
  ],
  "./ro.json": [
    "567590",
    "89715"
  ],
  "./ka.json": [
    "301153",
    "592073"
  ],
  "./hu.json": [
    "267336",
    "635629"
  ],
  "./ur.json": [
    "76112",
    "716475"
  ],
  "./or.json": [
    "196341",
    "675105"
  ],
  "./uz.json": [
    "5028",
    "357682"
  ],
  "./hy.json": [
    "252647",
    "855472"
  ],
  "./de.json": [
    "533424",
    "440857"
  ],
  "./pt-pt.json": [
    "388596",
    "968269"
  ],
  "./es-cl.json": [
    "321483",
    "811679"
  ],
  "./vi.json": [
    "31265",
    "366863"
  ],
  "./tr.json": [
    "847205",
    "211042"
  ],
  "./da.json": [
    "615954",
    "527674"
  ],
  "./kn.json": [
    "801659",
    "142109"
  ],
  "./mr.json": [
    "654073",
    "90758"
  ],
  "./id.json": [
    "22421",
    "822384"
  ],
  "./lt.json": [
    "116315",
    "239338"
  ],
  "./lv.json": [
    "935515",
    "357072"
  ],
  "./fv.json": [
    "67975",
    "677395"
  ],
  "./zh-hans.json": [
    "353845",
    "924419"
  ],
  "./es.json": [
    "297545",
    "671498"
  ],
  "./ko.json": [
    "832688",
    "999840"
  ],
  "./te.json": [
    "421922",
    "225359"
  ],
  "./bn.json": [
    "219678",
    "190036"
  ],
  "./cs.json": [
    "602460",
    "72516"
  ],
  "./boxes.json": [
    "894831",
    "180889"
  ],
  "./my.json": [
    "749217",
    "482577"
  ],
  "./mn.json": [
    "469584",
    "801742"
  ],
  "./sk.json": [
    "303531",
    "754852"
  ],
  "./nl.json": [
    "492641",
    "549141"
  ],
  "./az.json": [
    "568976",
    "681138"
  ],
  "./accents.json": [
    "492494",
    "611097"
  ],
  "./pa.json": [
    "771852",
    "415013"
  ],
  "./pt.json": [
    "944515",
    "357167"
  ],
  "./it.json": [
    "770541",
    "446253"
  ],
  "./km.json": [
    "608093",
    "295461"
  ],
  "./hi.json": [
    "419808",
    "843392"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 52378;
module.exports = webpackAsyncContext;
